var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40002 9.3999C8.40002 8.33904 7.9786 7.32162 7.22845 6.57147C6.47831 5.82133 5.46089 5.3999 4.40002 5.3999M4.40002 5.3999C3.33916 5.3999 2.32174 5.82133 1.5716 6.57147C0.821452 7.32162 0.400024 8.33904 0.400024 9.3999M4.40002 5.3999C5.78074 5.3999 6.90002 4.28061 6.90002 2.8999C6.90002 1.51919 5.78074 0.399902 4.40002 0.399902C3.01931 0.399902 1.90002 1.51919 1.90002 2.8999C1.90002 4.28061 3.01931 5.3999 4.40002 5.3999ZM10.4 8.8999C10.4 7.2149 9.40002 5.6499 8.40002 4.8999C8.72873 4.65329 8.99158 4.32945 9.16531 3.95704C9.33903 3.58463 9.41828 3.17514 9.39603 2.7648C9.37379 2.35447 9.25073 1.95595 9.03776 1.6045C8.82479 1.25306 8.52847 0.959533 8.17502 0.749902",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleWhite);
export default __webpack_public_path__ + "static/media/peopleWhite.e98a37ce77b8999f3e49ebd646840937.svg";
export { ForwardRef as ReactComponent };